<label
  (click)="!disabled && clicked.emit(!checked)"
  class="css-checkbox-container"
  [ngClass]="{ checked: checked, disabled: disabled }">
  <div class="css-checkbox" id="fake-box"></div>
  <span class="css-checkbox-label" [ngClass]="{ checked: checked }">
    {{ label }}
  </span>
  <span class="css-checkmark" [ngClass]="{ checked: checked }"></span>
</label>
